module.exports = __webpack_public_path__ + "static/media/4.9a5f8257.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/4.png
// module id = 1305
// module chunks = 0